import { AuthState } from './types'

const initialState: AuthState = {
  deviceId: '',
  isDeviceIdUpdating: false,
  error: undefined,
  isLogoutRequired: false
}

export default initialState
